const TasasEnum = {
    IGV: {
        id: 1,
        valor: 0.18,
    },
}

export default TasasEnum